export default [
  //资料库
  {
    path: '/ziliaoku',
    component: () => import('@/views/ziliaoku/index'),
    redirect: '/ziliaoku/ziliaoku',
    children: [
      {
        path: '/ziliaoku/ziliaoku',
        component: () => import('@/views/ziliaoku/ziliaoku'),
        mete: {
          title: "资料库",
        },
      },
      {
        path: '/ziliaoku/kefu',
        component: () => import('@/views/ziliaoku/kefu'),
        mete: {
          title: "客服资料库",
        },
      },
      {
        path: '/ziliaoku/kefu/kefu_shop',
        component: () => import('@/views/ziliaoku/kefu_shop'),
        mete: {
          title: "客服资料库商品",
        },
      },
      {
        path: '/ziliaoku/shop_detail',
        component: () => import('@/views/ziliaoku/shop_detail'),
        mete: {
          title: "商品详情",
        },
      },

    ]
  },
  {
  	path: '/shops_list',
  	name: 'shops_list',
  	component: () => import('@/views/ziliaoku/shops_list')
  },
  {
  	path: '/shops_detail',
  	name: 'shops_detail',
  	component: () => import('@/views/ziliaoku/shops_detail')
  },
  
  // {
  // 	path: '/gongju/order_export_haoma_daoru',
  // 	name: 'order_export_haoma_daoru',
  // 	component: () => import('@/components/productionManagement/order_export_haoma_daoru')
  // }
]



// WEBPACK FOOTER //
// ./src/router/ziliaoku.js